import { useState, useRef, useEffect, Fragment } from "react";
import { Auth } from "aws-amplify";
import Box from "@mui/material/Box";
import { Stack, Typography, useTheme, useMediaQuery } from "@mui/material";
import Toast from "../../utils/Toast";
import LoadingCircle from "../../utils/LoadingCircle";
import { HttpMainApi } from "../../interface/main-api";
import { userState } from "../../interface/MainInterface";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Paper from "@mui/material/Paper";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import Select, { SelectChangeEvent } from "@mui/material/Select";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import ReservTimeList from "../components/ReservTimeList";
import { getFormattedDateTime } from "../../utils/getFormattedDateTime";
import ReservRoomList from "../components/ReservRoomList";
const mainApi = new HttpMainApi();
interface propsType {
  userState: userState;
}
interface ReservationDetail {
  deviceNum: string;
  reservTime: string;
  reservDt: string;
  userName: string;
  userId: string;
  inputDt: string;
}
interface Reservation {
  sk: string;
  pk: string;
  reservations: { [key: string]: ReservationDetail };
}

type ButtonType = {
  key: string;
  label: string;
  isRepair: boolean; // 수리중 여부
};
export type GolfDevice = {
  deviceId: string;
  label: string;
  isRepair: boolean;
  availabilityStatus?: GolfDeviceAvailabilityStatus;
  repairReason?: string;
  updatedAt?: string;
  order?: number;
};

type GolfDeviceAvailabilityStatus = "OPERATING" | "UNDER_REPAIR" | "OPENING_SOON";

const DEVICE_STATUS_OPTIONS: { value: GolfDeviceAvailabilityStatus; label: string }[] = [
  { value: "OPERATING", label: "운영" },
  { value: "UNDER_REPAIR", label: "수리중" },
  { value: "OPENING_SOON", label: "오픈 예정" },
];

const BOOK_CAFE_DEVICE_ID = "BOOKCAFE";
const TABLE_TENNIS_DEVICE_ID = "TABLETENNIS";

const getDeviceStatusOptions = (device: GolfDevice) =>
  DEVICE_STATUS_OPTIONS.map((option) =>
    option.value === "OPERATING" && [BOOK_CAFE_DEVICE_ID, TABLE_TENNIS_DEVICE_ID].includes(device.deviceId)
      ? { ...option, label: "예약 신청" }
      : option,
  );

const getDeviceAvailabilityStatus = (device: GolfDevice): GolfDeviceAvailabilityStatus =>
  device.availabilityStatus ?? (device.isRepair ? "UNDER_REPAIR" : "OPERATING");

const ReservationScreenAdmin = (props: propsType) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const useTimeValues: string[] = ["18:00", "19:00", "20:00", "21:00", "22:00"];
  const [holidays, setHolidays] = useState<string[]>([]);
  const [stopDay, setStopDay] = useState<string[]>([]);
  const [stopDayMemo, setStopDayMemo] = useState("");
  const [devices, setDevices] = useState<GolfDevice[]>([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
  const [isTimeLoading, setIsTimeLoading] = useState(false);

  const today = new Date()
    .toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replace(/. /g, "-")
    .replace(".", "");
  function createMarkup(text: string): JSX.Element[] {
    const paragraphs = text.split(/<br><\/br>/gi);
    return paragraphs.map((paragraph, index) => (
      <Fragment key={index}>
        {paragraph}
        {index < paragraphs.length - 1 && <br />}
      </Fragment>
    ));
  }

  const isStopday = stopDay.includes(today);
  const isHoliday = holidays.includes(today);

  const get_repair_list = async () => {
    setIsLoading(true);
    const pk = "COMMUNITY/REPAIR";
    const sk = "GOLF";
    const param: any = {
      pk: pk,
      sk: sk,
    };
    // console.log("param : ", param);
    const [res, bookCafePolicyRes, tableTennisPolicyRes] = await Promise.all([
      mainApi.get_holiday_list(param),
      mainApi.get_book_cafe_policy({}),
      mainApi.get_table_tennis_policy({}),
    ]);
    if (res.code === "200") {
      const devices: GolfDevice[] = res.response?.result?.[0]?.devices || [];
      const nextDevices = [...devices];
      for (const facility of [
        { deviceId: BOOK_CAFE_DEVICE_ID, label: "북카페", order: 7, policy: bookCafePolicyRes.response },
        { deviceId: TABLE_TENNIS_DEVICE_ID, label: "탁구장", order: 8, policy: tableTennisPolicyRes.response },
      ]) {
        if (nextDevices.some((device) => device.deviceId === facility.deviceId)) continue;
        const availabilityStatus: GolfDeviceAvailabilityStatus =
          facility.policy?.availabilityStatus ?? (facility.policy?.bookingEnabled ? "OPERATING" : "OPENING_SOON");
        nextDevices.push({
          deviceId: facility.deviceId,
          label: facility.label,
          order: facility.order,
          availabilityStatus,
          isRepair: availabilityStatus !== "OPERATING",
        });
      }
      setDevices(nextDevices);
    } else {
      alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  type ValuePiece = Date | null;
  type Value = ValuePiece | [ValuePiece, ValuePiece];
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedMonth = month < 10 ? `0${month}` : `${month}`;
    const formattedDay = day < 10 ? `0${day}` : `${day}`;
    return `${year}${formattedMonth}${formattedDay}`;
  };

  const formatDate2 = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedMonth = month < 10 ? `0${month}` : `${month}`;
    const formattedDay = day < 10 ? `0${day}` : `${day}`;
    return `${year}년 ${formattedMonth}월 ${formattedDay}일`;
  };

  const [buttons, setButtons] = useState<ButtonType[]>([
    { key: "타석1", label: "타석1", isRepair: false },
    { key: "타석2", label: "타석2", isRepair: false },
    { key: "ROOM", label: "ROOM (유료)", isRepair: false },
  ]);

  const toggleRepair = (buttonKey: string) => {
    setButtons((prev) => prev.map((btn) => (btn.key === buttonKey ? { ...btn, isRepair: !btn.isRepair } : btn)));
  };

  function isDisabled(date: Date): boolean {
    return false; // 365일 영업
  }

  function findFirstValidDate() {
    const today = new Date();
    let date = new Date(today);
    let tempDate = "";
    if (isDisabled(date)) {
      tempDate = "";
    } else {
      tempDate = formatDate(date);
    }

    return tempDate;
  }

  const [selectedDevice, setSelectedDevice] = useState(buttons[0].key);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [selectDate, setSelectDate] = useState(findFirstValidDate());
  const [selectformatDate, setSelectformatDate] = useState(formatDate2(new Date()));
  const [isPageLoading, setIsPageLoading] = useState(false);

  const handleButtonClick = (deviceId: string) => {
    const target = devices.find((d) => d.deviceId === deviceId);
    if (target?.isRepair) return; // 수리중이면 무시
    setIsPageLoading(true); // ⭐ 화면 전체 잠금
    setSelectedTime(null);
    setSelectedTimes([]);
    setSelectedDeviceId(deviceId);
    setSelectedDevice(deviceId);
    setHole("60");
    setPeople("1");
    setUseTime(60);
    setMaxTime(2);
  };

  const [times, setTimes] = useState<string[]>([]);

  const extractReservationTimes = (reservationData: Reservation[]): string[] => {
    return reservationData.flatMap((item) => Object.keys(item.reservations).flatMap((time) => time.split(",")));
  };

  const get_day_reservation = async () => {
    setIsTimeLoading(true);

    const pk = `${selectDate}/SCREEN`;
    const sk = selectedDevice;

    const param: any = { pk, sk };
    const res = await mainApi.get_day_reservation(param);

    if (res.code === "200") {
      const extractedTimes = extractReservationTimes(res.response.result);
      setTimes(extractedTimes);
    } else {
      setTimes([]); // 실패 시에도 비워서 안전
    }

    setIsTimeLoading(false);
  };

  //이곳에 저장하는 함수
  // {
  //   "pk": "COMMUNITY/REPAIR",
  //   "sk": "GOLF",
  //   "devices": [
  //    {
  //     "deviceId": "타석1",
  //     "isRepair": false,
  //     "label": "타석1",
  //     "order": 1
  //    },
  //    {
  //     "deviceId": "타석2",
  //     "isRepair": false,
  //     "label": "타석2",
  //     "order": 2
  //    },
  //    {
  //     "deviceId": "ROOM",
  //     "isRepair": false,
  //     "label": "ROOM (유료)",
  //     "order": 3
  //    }
  //   ],
  //   "updatedAt": "2026-01-28T00:00:00Z"
  //  }

  const handleAvailabilityStatusChange = async (
    device: GolfDevice,
    availabilityStatus: GolfDeviceAvailabilityStatus | null,
  ) => {
    if (!availabilityStatus || availabilityStatus === getDeviceAvailabilityStatus(device)) return;

    const prev = [...devices];
    const isRepair = availabilityStatus !== "OPERATING";

    setDevices((current) =>
      current.map((item) =>
        item.deviceId === device.deviceId ? { ...item, availabilityStatus, isRepair } : item,
      ),
    );

    try {
      await update_repair(device.deviceId, availabilityStatus, isRepair);
    } catch {
      // 실패 시 롤백
      setDevices(prev);
    }
  };

  const update_repair = async (
    deviceId: string,
    availabilityStatus: GolfDeviceAvailabilityStatus,
    isRepair: boolean,
  ) => {
    setIsLoading(true);

    const pk = "COMMUNITY/REPAIR";
    const sk = "GOLF";

    const param: any = { pk, sk, deviceId, availabilityStatus, isRepair };
    try {
      const res = await mainApi.update_repair(param);

      if (res.code === "200") {
        toastRef.current?.show?.("운영 상태가 저장되었습니다.");

        // ⭐ 서버 기준으로 다시 조회 (권장)
        await get_repair_list();
      } else {
        alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
        throw new Error(res.response?.error_msg || "운영 상태 저장 실패");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const loadAll = async () => {
      await Promise.all([get_repair_list()]);
    };

    if (selectedDevice && selectDate) {
      loadAll();
    }
  }, [selectedDevice, selectDate]);

  //ROOM
  const [people, setPeople] = useState("1");
  const [hole, setHole] = useState("60");
  const [useTime, setUseTime] = useState(60);
  const [selectedTimes, setSelectedTimes] = useState<string[]>([]);
  const [maxTime, setMaxTime] = useState(2);
  const handleChange = (event: SelectChangeEvent) => {
    setPeople(event.target.value as string);
    const peopleString = event.target.value as string;
    const peopleNumber = parseInt(peopleString, 10);
    const holeNumber = parseInt(hole, 10);
    setUseTime(peopleNumber * holeNumber);
    setMaxTime(Math.ceil((peopleNumber * holeNumber) / 30));
    setSelectedTimes([]);
  };

  useEffect(() => {
    if (devices.length > 0 && !selectedDeviceId) {
      const firstAvailable = devices.find((d) => !d.isRepair);
      if (firstAvailable) {
        setSelectedDeviceId(firstAvailable.deviceId);
      }
    }
  }, [devices, selectedDeviceId]);

  return (
    <>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          width: "100%",
          maxWidth: isMobile ? "100%" : "40rem",
          margin: "auto",
        }}
      >
        <hr style={{ borderColor: "#ddd", borderWidth: "0.3px", width: "100%" }} />

        <Box
          sx={{
            width: "90%",
            maxWidth: isMobile ? "100%" : "40rem",
            margin: "auto",
          }}
        ></Box>

        <Stack spacing={2} sx={{ width: "100%", px: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            시설 예약 상태 관리
          </Typography>

          {[...devices] // ⭐ 복사
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
            .map((device) => {
              const availabilityStatus = getDeviceAvailabilityStatus(device);
              const statusLabel = DEVICE_STATUS_OPTIONS.find((option) => option.value === availabilityStatus)?.label;
              const statusOptions = getDeviceStatusOptions(device);

              return (
                <Paper
                  key={device.deviceId}
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: isMobile ? "stretch" : "center",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                  elevation={1}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 500 }}>{device.label}</Typography>
                    {availabilityStatus !== "OPERATING" && (
                      <Typography
                        variant="caption"
                        color={availabilityStatus === "UNDER_REPAIR" ? "error" : "warning.main"}
                        sx={{ display: "block" }}
                      >
                        현재 {statusLabel}
                      </Typography>
                    )}
                  </Box>

                  <ToggleButtonGroup
                    exclusive
                    value={availabilityStatus}
                    aria-label={`${device.label} 운영 상태`}
                    onChange={(_event, nextStatus) => handleAvailabilityStatusChange(device, nextStatus)}
                    sx={{
                      alignSelf: isMobile ? "stretch" : "center",
                      "& .MuiToggleButton-root": {
                        flex: 1,
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    {statusOptions.map((option) => (
                      <ToggleButton key={option.value} value={option.value} disabled={isLoading}>
                        {option.label}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </Paper>
              );
            })}
        </Stack>
      </Stack>
      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default ReservationScreenAdmin;
